import { Inject, Injectable } from '@angular/core';
import { ErrorService } from '../services/error.service';
import { EnvironmentType } from '../models/environment.type';
import { ENVIRONMENT, SESSION_STORAGE, WINDOW } from '../shared/injections/window';
import { take } from 'rxjs/operators';

@Injectable()
export class SendEventHelper {
  constructor(
    @Inject(WINDOW) private readonly window: Window,
    @Inject(ENVIRONMENT) private environment: EnvironmentType,
    private errorService: ErrorService,
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
  ) {}

  public send(message: string | any, phone: string | number = this.sessionStorage.getItem('phone'), type: string = 'WARN'): void {
    if (this.environment.production) {
      const stackLines = message?.stack?.split('\n');
      let errorLocation: string = '';
      if (stackLines?.length > 1) {
        errorLocation = stackLines[1].trim();
      }
      if (message?.error) {
        message = message.error.message;
      }
      const website = this.environment.name;
      const url = this.window.location.pathname;
      const tokenParam = this.sessionStorage.getItem('jwt_token') ? `&token=${this.sessionStorage.getItem('jwt_token')}` : '';
      const errorLocationParam = errorLocation ? `&errorLocation=${errorLocation}` : '';
      const param = `${type}?website=${website}&phone=${phone}${tokenParam}&message=${message}&url=${url}${errorLocationParam}`;
      this.errorService.sendErrors(param).pipe(take(1)).subscribe();
    } else {
      if (typeof message !== 'string') {
        console.error(message);
      }
    }
  }
}
